module.exports = __webpack_public_path__ + "static/media/losangelesst.a3546cfc.jpg";